module.exports = __webpack_public_path__ + "static/media/Navigate Theme – Literature – 1.0327b473.jpg";